import $ from "jquery";
import "parsleyjs";
import Cookies from 'js-cookie';
import { qs } from '@/utils/dom';
const ModalLeaflet = {
    init: () => {
        const $modalLeaflet = document.getElementById("modalLeaflet");
        if ($modalLeaflet === null)
            return;
        ModalLeaflet.show($modalLeaflet);
        ModalLeaflet.formValidate($modalLeaflet);
    },
    show: (modal) => {
        modal.addEventListener("show.bs.modal", function (event) {
            const relatedTarget = event.relatedTarget;
            const productId = relatedTarget.getAttribute("data-product-id");
            const productName = relatedTarget.getAttribute("data-product-name");
            const downloadFile = relatedTarget.getAttribute("data-download-file");
            const inputProductId = document.querySelector('[name="product_id"]');
            const inputProductName = document.querySelector('[name="product_name"]');
            const inputDownloadFile = modal.querySelector('[name="download_file"]');
            const inputInterested = modal.querySelector('[name="interested"]');
            inputProductId.value = productId;
            inputProductName.value = productName;
            inputDownloadFile.value = downloadFile;
            inputInterested.checked = false;
            ModalLeaflet.prefillForm(modal);
        });
    },
    // setBuField: (modal: HTMLElement) => {
    //   const inputBu = modal.querySelector('[name="bu"]') as HTMLInputElement;
    //   const { pathname } = window.location;
    //   const isResourcePage = pathname.split('/')[2] === 'resources' ? true : false; 
    //   if (isResourcePage) {
    //     const navClassify = document.querySelector('.nav-classify');
    //     const activeNavLink = navClassify.querySelector('.nav-link.active');  
    //     inputBu.value = activeNavLink.textContent.trim();
    //   } else {
    //     const activeBreadcrumb = document.querySelector('.breadcrumb-item:first-child');
    //     inputBu.value = activeBreadcrumb.textContent.trim();
    //   }
    // },
    prefillForm: (modal) => {
        const form = modal.querySelector(".form");
        let isCookieExist = false;
        let formDataLeaflet = {
            name: '',
            email: '',
            companyName: '',
            telephone: '',
            country: '',
        };
        try {
            const formDataLeafletCookie = Cookies.get('formDataLeaflet');
            formDataLeaflet = JSON.parse(formDataLeafletCookie);
            isCookieExist = true;
        }
        catch (err) {
            console.error('formDataLeaflet Cookie not found');
        }
        if (isCookieExist) {
            const inputName = form.querySelector('[name="name"]');
            const inputEmail = form.querySelector('[name="email"]');
            const inputCompanyName = form.querySelector('[name="company_name"]');
            const inputTelephone = form.querySelector('[name="telephone"]');
            const selectCountry = form.querySelector('[name="country"]');
            inputName.value = formDataLeaflet.name;
            inputEmail.value = formDataLeaflet.email;
            inputCompanyName.value = formDataLeaflet.companyName;
            inputTelephone.value = formDataLeaflet.telephone;
            selectCountry.value = formDataLeaflet.country;
            inputName.classList.add('focus');
            inputEmail.classList.add('focus');
            inputCompanyName.classList.add('focus');
            inputTelephone.classList.add('focus');
            $(selectCountry).trigger('change');
        }
        const alert = modal.querySelector('.alert');
        if (alert) {
            modal.querySelector('.alert').remove();
        }
    },
    formValidate: (modal) => {
        const form = modal.querySelector(".form");
        form.addEventListener('submit', (event) => {
            const inputName = form.querySelector('[name="name"]');
            const inputEmail = form.querySelector('[name="email"]');
            const inputCompanyName = form.querySelector('[name="company_name"]');
            const inputTelephone = form.querySelector('[name="telephone"]');
            const selectCountry = form.querySelector('[name="country"]');
            const btnSubmit = form.querySelector('button[type="submit"]');
            const inputInterested = form.querySelector('[name="interested"]');
            const modalThankyou = qs('#modalLeafletThankyou');
            const { sitekey } = btnSubmit.dataset;
            const formDataLeaflet = {
                name: inputName.value,
                email: inputEmail.value,
                companyName: inputCompanyName.value,
                telephone: inputTelephone.value,
                country: selectCountry.value,
            };
            if (inputInterested.checked) {
                modalThankyou.querySelector('.is-interested').classList.remove('d-none');
                modalThankyou.querySelector('.not-interested').classList.add('d-none');
            }
            else {
                modalThankyou.querySelector('.is-interested').classList.add('d-none');
                modalThankyou.querySelector('.not-interested').classList.remove('d-none');
            }
            if ($(form).parsley().isValid()) {
                Cookies.set('formDataLeaflet', JSON.stringify(formDataLeaflet), { expires: 30 });
                window.grecaptcha.ready(() => {
                    window.grecaptcha.execute(sitekey, { action: 'submit' }).then(function (token) {
                    });
                });
            }
            event.preventDefault();
        });
    },
};
export default ModalLeaflet;
